exports = module.exports = require("../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tableStyle thead tr {\n  background-color: \"#d3d3d399\"; }\n\n.tableHeadStyle,\n.material-table-row {\n  font-family: Roboto;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  letter-spacing: 0.5px;\n  text-align: center !important;\n  color: #767676 !important; }\n\n.material-table-row td,\n.tableHeadStyle {\n  font-size: 13px;\n  color: #484848;\n  font-weight: normal;\n  padding: 4px 8px 4px 8px !important;\n  text-align: center !important;\n  max-width: 295px;\n  word-wrap: break-word; }\n\n.material-table-pagination span {\n  font-size: 14px; }\n\n.TableUi-tableWrapper-3 {\n  overflow: hidden !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/Tables/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/Tables/index.css
// module chunks = 504